<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import {
		resolveFlowNodeTypeLabel,
		resolveTimeConditionSummary,
	} from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = resolveTimeConditionSummary(data);
	$: nodeTypeLabel = resolveFlowNodeTypeLabel('timeCondition', data);
</script>

<BaseConditionNode
	{id}
	type="timeCondition"
	hideFalseOutput={true}
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={displayText}
	{nodeTypeLabel}
	{...$$restProps}
/>
